const styles = (theme) => ({
  labelText: {
    textAlign: 'left',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '70vw',
    color: theme.palette.common.black,
  },
});

export const spinnerStyles = (theme) => ({
  root: {
    position: 'relative',
    width: '16px',
    height: '16px',
  },
  top: {
    color: theme.palette.common.white,
    animationDuration: '900ms',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '16px',
    position: 'absolute',
    left: 0,
    top: 0,
    padding: '3px',
  },
  circle: {
    strokeLinecap: 'round',
  },
});

export const downloadDecoratorStyles = (theme) => ({
  root: {
    border: '1px solid white',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
});

export const downloadedDecoratorStyles = (theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    color: '#40c740',
  },
});

export const attachmentButtonStyles = (theme) => ({
  'root': {
    width: '13.5rem',
    height: '4rem',
    paddingRight: '.5rem',
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  'label': {
  },
  'startIcon': {
    'marginRight': '13px',
    'marginLeft': '0px',
    'position': 'relative',
    'display': 'flex',
    'flexDirection': 'column',
    'justifyContent': 'space-around',
    'color': theme.palette.primary.main,
    '& .startIconDecoratorContainer': {
      display: 'flex',
      position: 'absolute',
      right: '-8px',
      bottom: '-6px',
      zIndex: '2',
      width: '16px',
      height: '16px',
      borderRadius: '20px',
      overflow: 'hidden',
    },
  },
  'iconSizeLarge': {
    '& > *': {
      fontSize: '1.9rem !important',
    },
  },
  'outlinedPrimary': {
    'fontWeight': 'normal',
    'backgroundColor': theme.palette.common.white,
    'color': theme.palette.common.black,
    'border': `1px solid ${theme.palette.common.swatch[400]}`,
    '&:hover': {
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.palette.common.swatch[400]}`,
    },
    '&:focus-visible': {
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.palette.primary.swatch[400]}`,
      boxShadow: `0px 2px 3px ${theme.palette.primary.swatch[400]}`,
    },
    '&:focus': {
      backgroundColor: theme.palette.common.white,
    },
  },
  'outlinedSizeLarge': {
    fontSize: '.8rem',
  },
});

export const attachmentInfoContainerStyles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    width: '100%',
  },
});

export const attachmentCaptionContainerStyles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyItems: 'evenly-spaced',
    color: theme.palette.common.swatch[600],
  },
});

export default styles;
